






























































import { Vue, Component, Prop } from 'vue-property-decorator';
import NavBar from '../components/common/NavBar.vue';
import InputField from '../components/common/inputs/InputField.vue';
import Button from '../components/common/inputs/Button.vue';
import { ITSystem } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import EditIcon from '../components/icons/EditIcon.vue';
import DeleteIcon from '../components/icons/DeleteIcon.vue';

@Component({
  components: {
    NavBar,
    InputField,
    Button,
    EditIcon,
    DeleteIcon
  }
})
export default class ManageSystems extends Vue {
  newITSystemName = '';
  newITSystemVendor = '';

  editing: number | null = null;

  get itsystems() {
    return CommonModule.itSystems;
  }

  mounted() {
    this.load();
  }

  async load() {
    CommonModule.loadITSystems();
  }

  edit(itsystem: ITSystem) {
    if (!itsystem.name) {
      return;
    }

    CommonModule.editITSystems(itsystem);
    this.editing = null;
  }

  remove(id: number) {
    if (confirm('よろしいですか？')) {
      CommonModule.removeITSystem(id);
    }
  }

  async add() {
    if (!this.newITSystemName) {
      return;
    }

    const name = this.newITSystemName;
    const vendor = this.newITSystemVendor;

    this.newITSystemName = '';
    this.newITSystemVendor = '';

    await CommonModule.addITSystem({ name, vendor });
  }
}
